/**
 * Gets authorization JWT from response headers
 * @param headers Headers of response to get authorization JWT from
 * @returns Extracted string JWT or null if header was absent in response ones
 */
export var getTokenFromHeaders = function (headers) {
    var authHeaderValue = headers.get("Authorization" /* Authorization */);
    return authHeaderValue ? authHeaderValue.replace("Bearer" /* Bearer */ + " ", '') : null;
};
